<template lang="pug">
transition(name="load")
  .loading(v-show="this.$parent.loading")
    .fullview
      .loading-spacer
      //- vue-loading(
        type="spin"
        color="#DB1016"
        :size="{ width: '50px', height: '50px' }")
</template>
<script>
import { VueLoading } from 'vue-loading-template'

export default {
  name: 'loading',
  components: {
    VueLoading,
  },
}
</script>
<style lang="scss" scoped>
.load-enter-active{
  transition: opacity 200ms
}
.load-leave-active {
  transition: opacity 500ms
}
.load-enter, .load-leave-to {
  opacity: 0
}

.fullview{
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 902;
}
.loading-spacer{
  height: 30%;
}
</style>
